/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClauseSchemaV1Dto } from '../models/ClauseSchemaV1Dto';
import type { CreateClauseSchemaAppliesToManyV1Dto } from '../models/CreateClauseSchemaAppliesToManyV1Dto';
import type { CreateClauseSchemaV1Dto } from '../models/CreateClauseSchemaV1Dto';
import type { DeleteClauseSchemaAppliesToManyV1Dto } from '../models/DeleteClauseSchemaAppliesToManyV1Dto';
import type { DeleteManyRequestV1 } from '../models/DeleteManyRequestV1';
import type { DeleteManyResultV1 } from '../models/DeleteManyResultV1';
import type { PatchClauseSchemaV1Dto } from '../models/PatchClauseSchemaV1Dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ClauseSchemasService {
  /**
   * @param requestBody
   * @returns ClauseSchemaV1Dto create entity
   * @throws ApiError
   */
  public static clauseSchemaControllerV1CreateV1(
    requestBody: CreateClauseSchemaV1Dto,
  ): CancelablePromise<ClauseSchemaV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/clause-schemas',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @returns ClauseSchemaV1Dto a entity list
   * @throws ApiError
   */
  public static clauseSchemaControllerV1FindAllV1(): CancelablePromise<Array<ClauseSchemaV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/clause-schemas',
      errors: {
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param requestBody
   * @returns DeleteManyResultV1 batch delete result
   * @throws ApiError
   */
  public static clauseSchemaControllerV1RemoveManyV1(
    requestBody: DeleteManyRequestV1,
  ): CancelablePromise<DeleteManyResultV1> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/clause-schemas',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
      },
    });
  }
  /**
   * @param uuid clauseSchemaId
   * @returns ClauseSchemaV1Dto the entity
   * @throws ApiError
   */
  public static clauseSchemaControllerV1FindOneV1(
    uuid: string,
  ): CancelablePromise<ClauseSchemaV1Dto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/clause-schemas/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid clauseSchemaId
   * @param requestBody
   * @returns ClauseSchemaV1Dto the update entity
   * @throws ApiError
   */
  public static clauseSchemaControllerV1UpdatePartialV1(
    uuid: string,
    requestBody: PatchClauseSchemaV1Dto,
  ): CancelablePromise<ClauseSchemaV1Dto> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/v1/clause-schemas/{uuid}',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid clauseSchemaId
   * @returns ClauseSchemaV1Dto the entity
   * @throws ApiError
   */
  public static clauseSchemaControllerV1RemoveOneV1(
    uuid: string,
  ): CancelablePromise<ClauseSchemaV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/clause-schemas/{uuid}',
      path: {
        uuid: uuid,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param contractTypeId contractTypeId
   * @returns ClauseSchemaV1Dto a entity list
   * @throws ApiError
   */
  public static clauseSchemaControllerV1FindManyByContractTypeV1(
    contractTypeId: string,
  ): CancelablePromise<Array<ClauseSchemaV1Dto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/clause-schemas/by-contract-type/{contractTypeId}',
      path: {
        contractTypeId: contractTypeId,
      },
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
  /**
   * @param uuid clauseSchemaId
   * @param requestBody
   * @returns ClauseSchemaV1Dto create entity
   * @throws ApiError
   */
  public static clauseSchemaControllerV1CreateManyAppliesToV1(
    uuid: string,
    requestBody: CreateClauseSchemaAppliesToManyV1Dto,
  ): CancelablePromise<ClauseSchemaV1Dto> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/clause-schemas/{uuid}/applies-to/bulk',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
        409: `Conflict - Version mismatch (optimistic locking). Entity was modified by another request.`,
      },
    });
  }
  /**
   * @param uuid clauseSchemaId
   * @param requestBody
   * @returns ClauseSchemaV1Dto the entity
   * @throws ApiError
   */
  public static clauseSchemaControllerV1RemoveAppliesToBulkV1(
    uuid: string,
    requestBody: DeleteClauseSchemaAppliesToManyV1Dto,
  ): CancelablePromise<ClauseSchemaV1Dto> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/clause-schemas/{uuid}/applies-to/bulk',
      path: {
        uuid: uuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad Request - Invalid input data or validation failed`,
        401: `Unauthorized - Invalid or missing authentication token`,
        404: `Not Found - Entity with given UUID does not exist`,
      },
    });
  }
}
